const FILES_BASE = `${import.meta.env.VITE_FILES_URL || ""}/onboarding`;

export const LANGUAGES = [
  { code: "en", nameKey: "English" },
  { code: "de", nameKey: "Deutsch" },
  { code: "uk", nameKey: "Українська" },
  { code: "ru", nameKey: "Русский" },
] as const;

export const LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2"] as const;

export const AVATARS = [
  "artist",
  "asia-woman",
  "astronaut",
  "baby",
  "black-man",
  "black-lady",
  "business-man",
  "business-woman",
  "college-student",
  "designer",
  "doctor",
  "engineer",
  "farmer",
  "grand-father",
  "grand-mother",
] as const;

export const getAvatarUrl = (name: string) =>
  `${FILES_BASE}/avatars/${name}.png`;
